export const app_i18n = {
  text1:
    "Scannez le dos de votre carte d'identité ou la page de votre passeport où figure votre photo",
  text2: "Avez-vous des difficultés avec le scanner ?",
  text3: "Réessayer",
  text4: "Processus manuel",
  text5: "Bienvenue !!",
  text6: "Sélectionnez la date de séjour",
  text7: "Votre e-mail",
  text8: "Continuer",
  text9: "C'est parti !, presque terminé",
  text10: "Bienvenue",
  text11: "Bienvenue",
  text12: "Téléphone",
  text13:
    "Pour poursuivre le processus, vous devez accepter nos conditions générales.",
  text14: "J'accepte les conditions générales",
  text15: "Continuer",
  text16: "Vous pouvez signer dans le cadre gris que vous voyez à l'écran",
  text17: "Effacer",
  text18: "Enregistrer la signature",
  text19: "Veuillez apposer votre signature",
  text20: "Check-in effectué avec succès",
  text21:
    "Merci beaucoup, nous avons envoyé une copie du document signé sur votre WhatsApp",
  text22: "Besoin d'effectuer un autre check-in ?",
  text23: "Recommencer",
  text24: "Bienvenue  🤗",
  text25: "😃 Veuillez saisir les informations suivantes",
  text26: "Prénom",
  text27: "Nom",
  text28: "Sélectionnez le sexe",
  text29: "Sexe",
  text30: "Homme",
  text31: "Femme",
  text32: "Date de naissance",
  text33: "C'est parti !, on y est presque 😉",
  text34: "Sélectionnez la date de séjour.",
  text35: "E-mail",
  text36: "Saisir la pièce d'identité",
  text37: "Type de document",
  text38: "ID",
  text39: "PASSPORT",
  text40: "Saisissez le numéro de document",
  text41: "Vous devez sélectionner un pays",
  // here
  text42: "Pays",
  text43: "Liste des services d'hébergement disponibles",
  text44: "Chargement des services ...",
  text45: "Aucun service disponible",
  text46: "Demande de service envoyée avec succès",
  text47: "Un agent vous contactera pour finaliser la demande de service.",
  text48: "Retour",
  text49:
    "Demande de service envoyée avec succès, un superviseur vous contactera sous peu.",
  text50: "Prix",
  text51: "Description du service",
  text52: "Demander",
  text53: "Envoyer la demande de service",
  text54: "En envoyant la demande, un superviseur vous contactera",
  text55: "Envoyer",
  text56: "Demande de service envoyée avec succès.",
  text57: "Erreur, impossible de demander le service",
  text58: "Envoi des données de check-in, veuillez patienter...",
  text59: "Chargement...",
  text60: "a effectué le check-in avec succès.",
  text61: `🎁 Cliquez ici pour voir tous nos services disponibles à l'hôtel`,
  text62: "Enregistrement d'entrée",
  text63: "Préfère ne pas répondre",
  text64: "Autre",
  text65: "Pays",
  text66: "Erreur",
  text67: "Hébergement désactivé.",
  text68: "Le propriétaire a désactivé les check-ins.",
  text69: "Sélectionnez la date",
  text70: "Du - Au",
  text71: "Sélectionnez une option",
  text72: "Sélectionnez le pays *",
  text73: "Êtes-vous sûr de vouloir recommencer le processus",
  text74: "Vous perdrez les données enregistrées",
  text75: "Données du check-in",
  text76: "Signature du check-in",
  text77: "Signé",
  text78: "Bienvenue",
  text79: "Désolé, une erreur s'est produite lors de la déconnexion",
  text80: "Annuler le processus.",
  text81:
    "La création du premier hébergement est obligatoire pour le bon fonctionnement du système.",
  text82: "Annuler et quitter",
  text83: "Continuer la modification",
  text84: "Rechercher...",
  text85: "Aucun enregistrement trouvé",
  text86: "Précédent",
  text87: "Suivant",
  text88: "Voulez-vous réessayer ou effectuer le processus manuel ?",
  text89: "Chargement ...",
  text90: "Services",
  text91: "Date de délivrance du document",
  text92: "Le champ Date de délivrance du document est obligatoire",
  p93: `chargement de votre...`,
  p94: `Données de la réservation`,
  p95: `Bienvenue`,
  p96: `Pour poursuivre le check-in, veuillez saisir les informations
    suivantes :`,
  p97: `Ce processus est une démonstration, aucune de vos données ne sera enregistrée`,
  p98: `Code de sécurité :`,
  p99: `Code de sécurité de l'hébergement`,
  p101: `Saisissez le code de sécurité`,
  p102: `Le code de sécurité est incorrect, veuillez vérifier et
    réessayer.`,
  p103: `Ou vous pouvez également`,
  p104: `Filtrer par code de check-in`,
  p105: `Continuer`,
  p106: `Code de check-in`,
  p107: `Saisissez le code de check-in`,
  p108: `Le code de check-in n'est pas enregistré sur notre plateforme, veuillez vérifier et réessayer.`,
  p109: `Saisissez le code de l'hébergement`,
  p110: `Check-in écologique`,
  p111: `Bienvenue !`,
  p112: `Veuillez préparer votre`,
  p112_1: `pièce d'identité ou passeport`,
  p112_2: `prêt à continuer`,
  p113: `Vous devrez accepter les`,
  p114: ` autorisations de la caméra 📷`,
  p115: ` elles sont nécessaires au bon fonctionnement de notre scanner.`,
  p116: `Continuer`,
  p117: `Sélectionnez la langue`,
  p118: `Saisissez le code de sécurité`,
  p119: `Scannez la page de votre passeport ou le dos de votre carte d'identité.`,
  p120: `Carte d'identité`,
  p121: `ID`,
  p122: `ou la page de votre passeport où figure votre photo`,
  p123: `Pour utiliser le scanner, il est nécessaire d'accorder les autorisations
    correspondantes à la caméra.`,
  p124: `Vérification de sécurité 🔐`,
  p125: `Pour vérifier votre numéro, nous avons envoyé un code sur votre`,
  p126: `WhatsApp`,
  p127: `Saisissez-le ici :`,
  p128: `Saisissez le code`,
  p129: `Code incorrect, veuillez vérifier et réessayer`,
  p130: `Retour`,
  p131: `Continuer`,
  p132: `Date d'entrée`,
  p133: `Date de sortie`,
  p134: `Date d'expiration`,
  p135: `Nationalité`,

  p136: `En cliquant`,
  p137: ` vous acceptez de signer le formulaire en votre nom, le contrat de location de courte durée`,
  p138: `Politiques de confidentialité`,
  p139: `Enregistrer la signature`,
  p140: `Informations de la réservation`,
  p141: `RÉSERVATION :`,
  p142: `Entrée`,
  p143: `Sortie`,
  p144: `Payer`,
  p145: `Payé`,
  p146: `Vérification du paiement`,
  p147: `Check-in`,
  p148: `Réservation`,
  p149: `Services`,
  p150: `VÉRIFICATION D'IDENTITÉ`,
  p151: `Téléversez un selfie de votre visage, avec un bon éclairage s'il vous plaît`,
  p152: `Dans cette vue, vous pouvez téléverser une photo du <strong>recto de votre pièce d'identité`,
  p153: `Dans cette vue, vous pouvez téléverser une photo du <strong>verso de votre pièce d'identité`,
  p154: `Ouvrir la caméra`,
  p155: `Reprendre`,
  p156: `Vérifier l'identité`,
  p157: `Continuer`,
  p158: `Erreur lors de la vérification de votre identité.`,
  p159: `Veuillez réessayer.
    Vous pouvez prendre les photos dans un endroit bien éclairé et bien centrer votre document.`,
  p160: `Processus obligatoire*`,
  p161: `Réessayer`,
  p162: `Vérification de l'identité.`,
  p163: `Veuillez patienter ....`,
  p164: `Identité vérifiée avec succès`,
  p165: `Vous avez vérifié votre identité 🪪 avec succès, le processus de check-in est presque terminé 😎`,
  p166: `À consulter`,
  p167: `Pour demander ce service, vous devez effectuer votre check-in.`,
  p168: `Progression`,
  p169: `Date d'expiration du document`,
  p170: `Date d'entrée`,
  p171: `Date de sortie`,
  p172: `Téléphone`,
  p173: `Votre document n'a pas pu être scanné.`,
  p174: `L'adresse ne correspond à aucune réservation dans le système`,
  p175: `Informations du check-in`,
  p176: `Assistance`,
  p177: `Espagnol (Espagne)`,
  p178: `Anglais`,
  p179: `Arabe`,
  p180: `ID`,
  p181: `Passeport`,

  p182: `Sélectionnez le lien de parenté`,
  p183: `Fils/Fille`,
  p184: `Grand-père/Grand-mère`,
  p185: `Arrière-grand-père/Arrière-grand-mère`,
  p186: `Arrière-petit-fils/Arrière-petite-fille`,
  p187: `Beau-frère/Belle-sœur`,
  p188: `Conjoint(e)`,
  p189: `Frère/Sœur`,
  p190: `Petit-fils/Petite-fille`,
  p191: `Autre`,
  p192: `Père ou Mère`,
  p193: `Neveu/Nièce`,
  p194: `Beau-père/Belle-mère`,
  p195: `Oncle/Tante`,
  p196: `Tuteur/Tutrice`,
  p197: `Gendre/Belle-fille`,

  p198: `Le champ lien de parenté est obligatoire`,
  p199: `ID`,
  p200: `OTHER`,
  p201: `Numéro de support du document`,
  p202: `Le numéro de support du document est obligatoire`,

  p203: `Informations requises en vertu du Décret royal 933/2021`,
  p204: `En vertu du Décret royal 933/2021 du 26 octobre, nous devons collecter des données telles que votre adresse, votre code postal, votre mode de paiement et la date de paiement afin de respecter la réglementation en matière de sécurité.`,
  p205: `Adresse de résidence actuelle`,
  p206: `Adresse`,
  p207: `Code postal`,
  p208: `Mode de paiement`,
  p209: `Sélectionnez un mode de paiement`,
  p210: `Espèces`,
  p211: `Paiement à l'arrivée`,
  p212: `Carte de crédit`,
  p213: `Paiement mobile`,
  p214: `Plateforme de paiement`,
  p215: `Carte cadeau`,
  p216: `Virement`,
  p217: `Date de paiement`,
  p218: `Mode de paiement`,
  p219: `Date de paiement`,
  p220: "Pays de résidence",
  p221: "Ville de résidence",
  p222: "Adresse de résidence",
  p223: "Code postal de résidence",

  p224: "Sélectionnez une option",
  p225: "Y a-t-il des mineurs dans la réservation ?",
  p226: "Non",
  p227: "Oui",
  p228: "Document non autorisé",
  p229: "Veuillez vérifier et utiliser votre passeport valide pour continuer.",
  p230:`Scannez votre passeport ou carte d'identité`,

  p231: `La date de départ ne peut pas être antérieure à la date d'arrivée`,
  p232: `Adresse e-mail valide`,
  p233: `Champ obligatoire`,
  p234: `Le numéro de pièce d'identité n'est pas valide`,
  p235: `La date de départ ne peut pas être antérieure à la date de départ`,
  p236: `Vous devez indiquer s'il y a des enfants dans la réservation`,
  p237: `Vous devez sélectionner le lien de parenté lorsqu'il y a des enfants dans la réservation`,
  p238: `Erreur, le processus ne peut pas continuer`,
  p239: `Bienvenue !`,
  p240: `Veuillez préparer votre`,
  p241: `pièce d'identité ou passeport`,
  p242: `🪪 prête pour le processus automatisé`,
  p243: `Veuillez noter`,
  p244: `L'acceptation des autorisations de la caméra 📷`,
  p245: `est nécessaire au bon fonctionnement de notre scanner`,
  p246: `Scannez le dos de votre`,
  p247: `Effectuez votre enregistrement de check-in ici !`,
  p248: `Lien copié dans le presse-papiers`,
  p249: `Enregistrer un autre client`,
  p250: `WhatsApp`,
  p251: `Copier le lien`,
  p252: `Mode de paiement inconnu`,
  p253: `Le code postal est introuvable dans les enregistrements`,
  p254: `Expériences et services`,
  p255: `Tout ce qu'il vous faut pour profiter pleinement de votre séjour`,
};
